<template>
  <el-dialog style="text-align: center" title="更多操作" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">

    <el-select v-model="value" filterable placeholder="请选择操作" @change="selectOne">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>

    <div class="input_box" v-if="processType === 'stock'">
      <el-input size="medium" v-model="act_type" placeholder="请输入库存" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
    </div>
    <div class="input_box" v-else-if="processType === 'income'">
      <el-input size="medium" v-model="act_type" placeholder="请输入直推收益" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
    </div>
    <div class="input_box" v-else-if="processType === 'category'">
        <el-select v-model="act_type">
          <template v-for="cat in categoryList">
            <el-option
              :value="cat.category_id"
              :key="cat.category_id"
              :label="cat.name"
            ></el-option>
            <template v-if="cat.child !== undefined" v-for="two in cat.child">
              <el-option
                :value="two.category_id"
                :key="two.category_id"
                :label="two.name"
                style="padding-left: 30px"
              ></el-option>
              <template v-if="two.child !== undefined" v-for="three in two.child">
                <el-option
                  :value="three.category_id"
                  :key="three.category_id"
                  :label="three.name"
                  style="padding-left: 60px"
                ></el-option>
              </template>
            </template>
          </template>
        </el-select>
    </div>
    <div class="input_box" v-else-if="processType === 'brand'">
      <el-select v-model="act_type">
        <template v-for="cat in brandList">
          <el-option
            :value="cat.brand_id"
            :key="cat.brand_id"
            :label="cat.name"
          ></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option
              :value="two.brand_id"
              :key="two.brand_id"
              :label="two.name"
              style="padding-left: 30px"
            ></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option
                :value="three.brand_id"
                :key="three.brand_id"
                :label="three.name"
                style="padding-left: 60px"
              ></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </div>

    <el-button type="primary" style="display: block;margin: auto; margin-top: 12px;" @click="submitBatch">确定</el-button>
  </el-dialog>

</template>

<script>
import ProductApi from '@/api/product.js';

export default {
  data() {
    return {
      options: [{
        value: 'stock',
        label: '批量修改库存'
      }, {
        value: 'income',
        label: '批量修改直推收益'
      }, {
        value: 'del',
        label: '批量删除'
      }, {
        value: 'category',
        label: '批量修改分类'
      }, {
        value: 'brand',
        label: '批量修改品牌'
      }],
      value: '',
      act_type: '',
      processType: 'stock',
      /*是否显示*/
      dialogVisible: false,
      // 分类列表
      categoryList: [],
      // 品牌列表
      brandList: [],
    };
  },
  created() {
    this.dialogVisible = this.$parent.more_actions;
  },
  methods: {

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        })

      }
    },
    // 选择事件
    selectOne(e) {
      if (e === 'category') {
        // 获取分类列表
        ProductApi.catList({}).then(data => {
          this.categoryList = data.data.list
        });
        this.processType = 'category'
      } else if (e === 'brand') {
        // 获取品牌列表
        ProductApi.brandList2({}).then(data => {
          this.brandList = data.data.list
        });
        this.processType = 'brand'
      } else if (e === 'stock') {
        // 获取品牌列表
        this.processType = 'stock'
      } else if (e === 'income') {
        // 获取品牌列表
        this.processType = 'income'
      } else {
        this.processType = 'del'
      }
    },
    // 提交批量修改操作数据
    submitBatch() {
      // console.log(this.act_type,this.value,this.$parent.multipleSelection);
      // 获取父级选中的商品
      let product_ids = [];
      let params = this.$parent.multipleSelection;
      params.forEach((param) => {
        product_ids.push(param.product_id);
      })
      product_ids = product_ids.join(',');

      if (product_ids == '') {
        this.$message({
          message: '请选择要修改的商品',
          type: 'error'
        });
      } else {
        if (this.value == 'stock') {
          // 批量修改库存
          ProductApi.batchStock({
            product_ids: product_ids,
            num: this.act_type,
          }).then(data => {
            this.$message({
              message: '批量修改库存成功',
              type: 'success'
            });
            this.dialogFormVisible()
            this.$parent.getData();
          });

        } else if (this.value == 'income') {
          // 批量修改直推收益
          ProductApi.batchIncome({
            product_ids: product_ids,
            money: this.act_type,
          }).then(data => {
            this.$message({
              message: '批量修改收益成功',
              type: 'success'
            });
            this.dialogFormVisible()
            this.$parent.getData();
          });

        } else if (this.value == 'del') {
          // 批量删除商品
          ProductApi.batchDel({
            product_ids: product_ids,
          }).then(data => {
            this.$message({
              message: '批量删除商品成功',
              type: 'success'
            });
            this.dialogFormVisible()
            this.$parent.getData();
          });
        } else if (this.value === 'category') {
          // 批量 修改分类
          ProductApi.batchCategory({
            product_ids: product_ids,
            categoryId: this.act_type,
          }).then(data => {
            this.$message({
              message: '批量修改分类成功',
              type: 'success'
            });
            this.dialogFormVisible()
            this.$parent.getData();
          });
        } else if (this.value === 'brand') {
          // 批量删除商品
          ProductApi.batchBrand({
            product_ids: product_ids,
            brandId: this.act_type,
          }).then(data => {
            this.$message({
              message: '批量修改品牌成功',
              type: 'success'
            });
            this.dialogFormVisible()
            this.$parent.getData();
          });
        } else {
          this.$message({
            message: '请选择要执行的操作',
            type: 'error'
          });
        }
      }

    },
  }
}
</script>

<style scoped>
.input_box {
  margin: auto;
  margin-top: 10px;
  width: 29%;
}
</style>



// WEBPACK FOOTER //
// src/components/product/Actions.vue